import type { ProfiloAzienda } from "../profilo-azienda";

export const profiloAziendaFutura: ProfiloAzienda = {
  brand: "Futura Intelligence",
  studio: "Futura Law Firm",
  descrizione: "Workspace demo per organizzare pratiche, documenti e attività dello studio legale.",
  sede: "Milano, Italia",
  email: "segreteria@futura-law.example",
  telefono: "+39 02 5550 1840",
  membri: 8,
};
